import React from "react";
import { interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { useLanguage } from "../../locales/LanguageContext";

const FirstStage = ({
  stageTiming,
  firstUnit: propFirstUnit,
  secondUnit: propSecondUnit,
}) => {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();
  const { t, lang, firstUnit: ctxFirstUnit, secondUnit: ctxSecondUnit } =
    useLanguage();

  const firstUnit =
    propFirstUnit ||
    ctxFirstUnit ||
    t?.secondFrame?.firstStage?.firstUnit ||
    "";
  const secondUnit =
    propSecondUnit ||
    ctxSecondUnit ||
    t?.secondFrame?.firstStage?.secondUnit ||
    "";

  const getFontSize = (str) => {
    const len = String(str || "").length;
    if (lang === "en") {
      if (len > 5) return "7.5rem";
      if (len > 3) return "9.5rem";
      return "13rem";
    }
    if (len > 4) return "6.5rem";
    if (len > 3) return "8rem";
    return "10rem";
  };

  const textProgress = spring({
    fps,
    frame,
    config: {
      damping: 12,
      stiffness: 100,
    },
  });

  const textTranslateX = interpolate(textProgress, [0, 1], [800, 0]);

  return (
    <div
      style={{
        position: "absolute",
        left: "20%",
        width,
        height,
        display: "flex",
        alignItems: "center",
        lineHeight: "1",
        justifyContent: "center",
        transform: `translateX(${textTranslateX}px)`,
        opacity: interpolate(
          frame,
          [0, 20, stageTiming - 5, stageTiming],
          [0, 1, 1, 0],
          {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          },
        ),
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "auto 140px",
          alignItems: "center",
          columnGap: "24px",
          rowGap: "100px",
        }}
      >
        <h1
          style={{
            gridColumn: 1,
            gridRow: 1,
            justifySelf: "end",
            fontSize: getFontSize(firstUnit),
            fontWeight: "900",
            margin: 0,
            padding: 0,
            zIndex: 10,
          }}
        >
          {firstUnit}
        </h1>
        <svg
          width="150"
          height="150"
          viewBox="0 0 100 100"
          style={{
            gridColumn: 2,
            gridRow: 1,
          }}
        >
          <polygon points="50,15 95,85 5,85" fill="#32cd32" />
        </svg>

        <h1
          style={{
            gridColumn: 1,
            gridRow: 2,
            justifySelf: "end",
            fontSize: getFontSize(secondUnit),
            fontWeight: "900",
            margin: 0,
            padding: 0,
            zIndex: 10,
          }}
        >
          {secondUnit}
        </h1>
        <svg
          width="150"
          height="150"
          viewBox="0 0 100 100"
          style={{
            gridColumn: 2,
            gridRow: 2,
          }}
        >
          <polygon points="5,15 95,15 50,85" fill="#e80000" />
        </svg>
      </div>
    </div>
  );
};

export default FirstStage;
